import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import SecondaryNav from '../../../components/SecondaryNav';
import SectionTitle from '../../../components/SectionTitle';
import GlobalErrorPage from '../../pages/GlobalErrorPage';
import Loading from '../../../components/Loading';
import { getWebNotificationsFileboxNumber } from '../../../js/notifications/selectors';
import {
  getFileboxActualPath,
  isFileboxBlocked,
} from '../../../js/filebox/selectors';
import FileboxBlockedAlert from './FileboxBlockedAlert';

const messages = defineMessages({
  title: {
    id: 'Filebox.title',
    defaultMessage: 'Filebox',
  },
  list: {
    id: 'Filebox.list.navLabel',
    defaultMessage: 'List',
  },
  settings: {
    id: 'Filebox.settings.navLabel',
    defaultMessage: 'Settings',
  },
  notifications: {
    id: 'Filebox.notifications.navLabel',
    defaultMessage: 'Notifications',
  },
  favorites: {
    id: 'Filebox.favorites.navLabel',
    defaultMessage: 'Favourites',
  },
  deleted: {
    id: 'Filebox.deleted.navLabel',
    defaultMessage: 'Recycle bin',
  },
});

const Filebox = ({
  intl: { formatMessage },
  children,
  loading,
  error,
  scrolling,
  blocked,
  notificationsQuantity,
  path,
}) => {
  const nav = [
    {
      id: 'Filebox.list.linkLabel',
      href: `/filebox/list${path ? `/${path.join('/')}` : ''}`,
      label: messages.list,
    },
    {
      id: 'Filebox.favorites.linkLabel',
      href: '/filebox/favourites',
      label: messages.favorites,
      disabled: blocked,
    },
    {
      id: 'Filebox.deleted.linkLabel',
      href: '/filebox/deleted',
      label: messages.deleted,
      disabled: blocked,
    },
    {
      id: 'Filebox.settings.linkLabel',
      href: '/filebox/settings',
      label: messages.settings,
      disabled: blocked,
    },
    {
      id: 'Filebox.notifications.linkLabel',
      href: '/filebox/notifications',
      label: messages.notifications,
      notifications: notificationsQuantity,
      disabled: blocked,
    },
  ];
  return (
    <div className="border rounded bg-white h-100">
      <SectionTitle>{formatMessage(messages.title)}</SectionTitle>
      {error ? (
        <GlobalErrorPage />
      ) : loading ? (
        <Loading />
      ) : (
        <>
          <SecondaryNav tabs={nav} />
          <div
            className={
              scrolling
                ? 'yn-section-with-nav-scrolling'
                : 'yn-section-with-nav'
            }
          >
            {blocked ? <FileboxBlockedAlert /> : children}
          </div>
        </>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    notificationsQuantity: getWebNotificationsFileboxNumber(state),
    blocked: isFileboxBlocked(state),
    path: getFileboxActualPath(state),
  };
}

export default injectIntl(connect(mapStateToProps)(Filebox));
